import httpService from '@/services/httpService'

export const types = {
  ADD_KEYWORD_MOVEMENT_HISTORY: 'rank-zone/ADD_KEYWORD_MOVEMENT_HISTORY',
  RESET_KEYWORD_HISTORY: 'rank-zone/RESET_KEYWORD_HISTORY'
}

const state = {
  keywordHistory: []
}

const mutations = {
  [types.ADD_KEYWORD_MOVEMENT_HISTORY]: function (state, keywordHistory) {
    state.keywordHistory = keywordHistory
  },
  [types.RESET_KEYWORD_HISTORY]: function (state) {
    state.keywordHistory = []
  }
}
const actions = {
  async getKeywordHistory ({ commit }, { clientId, ...params }) {
    const msv = JSON.parse(localStorage.getItem('msv')) || {}
    params.msv = msv[clientId] || 1
    const response = await httpService.get(`/reports/rankzone-report/keyword-movement-history/${clientId}`, { params })
    if (response && response.data) {
      commit(types.ADD_KEYWORD_MOVEMENT_HISTORY, response.data.keyword_history)
    }
  },
  async updateKeywordData ({ commit }, { clientId, successMessage, ...params }) {
    return httpService.patch(`/reports/rankzone-report/keyword-update/${clientId}`, params, { successMessage })
  },
  resetKeywordHistory ({ commit }) {
    commit(types.RESET_KEYWORD_HISTORY)
  },
  async hashKeywordHistoryModal ({ commit }, { clientId, type, params }) {
    const form = JSON.stringify({ ...params })
    const response = await httpService.post(`/reports/rankzone-report/keyword-movement-history/${clientId}/views`, { form, type })
    if (response && response.data) {
      return response.data
    }
    return null
  },
  async getKeywordHistoryModal ({ commit }, { clientId, viewId }) {
    const params = { data: viewId }
    const response = await httpService.get(`/reports/rankzone-report/keyword-movement-history/${clientId}/views`, { params })
    if (response && response.data) {
      return response.data
    }
    return null
  },
}

/**
 * Store keep table data and has column's header's as a default. Used in KeywordMovementTable.vue
 */
export default {
  namespaced: true,
  state,
  actions,
  mutations
}
